import React from "react";
import { ExclamationIcon } from "../../../assets/images/svg";
import { useSelector } from "react-redux";

const AIError = ({ errorText = "" }) => {
  const errors = useSelector((state) => state.ai.errors);
  return (
    (errors || errorText) && (
      <div className="ai-error">
        <div className="ai-error__message">
          <ExclamationIcon className="icon" />
          <div>{errorText || "Oops! Something went wrong"}</div>
        </div>
      </div>
    )
  );
};

export default AIError;
